module.exports = __webpack_public_path__ + "Roboto-Light.woff2";